import { Component, input } from "@angular/core";
import { ParseMentionPipe } from "../../pipes";
import { NgFor } from "@angular/common";

@Component({
  selector: "app-mention-comment",
  imports: [NgFor, ParseMentionPipe],
  templateUrl: "./mention-comment.component.html",
  styleUrl: "./mention-comment.component.scss",
})
export class MentionCommentComponent {
  /** Prefix for mention - angular doesn't like @ in html */
  readonly prefix = "@";
  /** A string with HTML elements - parsed with pipe in component */
  comment = input.required<string>();
}
